<template>
  <div style="width: 98%; margin: 0 auto">
    <div class="infoBox">
      <el-row>
        <el-col :md="24" :lg="24" :xl="11">
          <el-col :md="24" :lg="24" :xl="24">
            <el-card class="box-card" style="margin-top: 10px">
              <div slot="header" class="clearfix" style="line-height: 20px">
                <span class="them">( 编号：{{ meeting.id }} )</span>
                <span class="them">{{ meeting.meeting_subject }}</span
                >&nbsp;&nbsp;&nbsp;
                <span
                  >早会预计时间：{{ meeting.estimate_start_time }} ~
                  {{ meeting.estimate_end_time }}</span
                >&nbsp;&nbsp;
                <span
                  >晚会预计时间：{{ meeting.night_estart_time }} ~
                  {{ meeting.night_eend_time }}</span
                >&nbsp;&nbsp; <span>最后更新：{{ meeting.update_time }}</span
                >&nbsp;&nbsp;
              </div>
              <el-row>
                <el-col :span="4">
                  <img
                    :src="meeting.room.avatar"
                    style="width: 100px; height: 100px"
                    alt
                  />
                </el-col>
                <el-col :span="20">
                  <div>
                    <span>会议室：{{ meeting.room.name }}</span
                    >&nbsp;&nbsp;&nbsp;&nbsp;
                    <span
                      >会议地点：{{ meeting.address.address }} -
                      {{ meeting.room.area }}</span
                    >
                  </div>
                  <p>
                    <span>参会人数：{{ meeting.number }}人</span>&nbsp;&nbsp;
                    <span>
                      <!-- 组件化 -->
                     <tags :meeting_status="meeting.meeting_status"></tags> </span>&nbsp;&nbsp;
                    <!-- <span>早会实际时间：{{ meeting.start_time }} ~ {{ meeting.end_time }}</span> -->
                    &nbsp;&nbsp;
                    <span>保密类型：{{ meeting.secrecy_type === 1 ? "一级会议（保密）" : "普通会议（非保密）" }}</span>
                  </p>
                  <p>
                    早会实际时间：{{ meeting.start_time }} ~
                    {{ meeting.end_time }}
                  </p>
                  <p>
                    晚会实际时间：{{ meeting.night_start_time }} ~
                    {{ meeting.night_end_time }}
                  </p>
                  <p>所属部门：{{ meeting.secretary_department_name }}</p>
                  <p>
                    <span>召集人：{{ meeting.convenor.name }}</span
                    >&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>会议秘书：{{ meeting.secretary.name }}</span
                    >&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>主持人：{{ meeting.host.name }}</span>
                  </p>
                  <span>
                    参会者：
                    <span
                      v-for="(items, index) in meeting.attendees"
                      :key="index"
                      >{{ items.name }} ,</span>
                  </span>
                  <el-button
                    v-if="
                      (meeting.secretary.workcode === $store.getters.username ||
                        meeting.host.workcode === $store.getters.username ||
                        meeting.convenor.workcode ===
                          $store.getters.username) &&
                      meeting.meeting_status === 1
                    "
                    type="text"
                    size="small"
                    @click="addAttendeesVisible = true"
                    >添加参会人</el-button
                  >
                  <p>
                    <el-tag
                      v-for="(items, index) in meeting.equipments"
                      :key="index"
                      type="info"
                      size="small"
                      effect="plain"
                      style="margin-left: 5px"
                      >{{ items.equipment_name }}</el-tag>
                  </p>
                  <el-button
                    v-if="
                      meeting.meeting_status === 0 &&
                      (meeting.secretary.workcode === $store.getters.username ||
                        meeting.host.workcode === $store.getters.username ||
                        meeting.convenor.workcode === $store.getters.username)
                    "
                    type="text"
                    size="medium"
                    @click="meetingstarts(meeting)"
                    >开始早会</el-button
                  >
                  <el-button
                    v-if="
                      meeting.meeting_status === 1 &&
                      (meeting.secretary.workcode === $store.getters.username ||
                        meeting.host.workcode === $store.getters.username ||
                        meeting.convenor.workcode === $store.getters.username)
                    "
                    type="text"
                    size="medium"
                    @click="meetingends()"
                    >结束早会</el-button
                  >
                  <el-button
                    v-if="
                      (meeting.meeting_status === 2 ||
                        meeting.meeting_status === 5) &&
                      (meeting.secretary.workcode === $store.getters.username ||
                        meeting.host.workcode === $store.getters.username ||
                        meeting.convenor.workcode ===
                          $store.getters.username) &&
                      meeting.night_start_time === '0000-00-00 00:00:00' &&
                      !meeting.overTime
                    "
                    type="text"
                    size="medium"
                    @click="nightmeeting_start(meeting)"
                    >开始晚会</el-button
                  >
                  <el-button
                    v-if="
                      (meeting.meeting_status === 2 ||
                        meeting.meeting_status === 5) &&
                      (meeting.secretary.workcode === $store.getters.username ||
                        meeting.host.workcode === $store.getters.username ||
                        meeting.convenor.workcode ===
                          $store.getters.username) &&
                      meeting.night_start_time !== '0000-00-00 00:00:00' &&
                      meeting.night_end_time === '0000-00-00 00:00:00' &&
                      !meeting.overTime
                    "
                    type="text"
                    size="medium"
                    @click="nightmeeting_end(meeting)"
                    >结束晚会</el-button
                  >
                </el-col>
              </el-row>
            </el-card>
          </el-col>

          <el-col :md="24" :lg="11" :xl="24">
            <el-tabs v-model="activeNamehui">
              <el-tab-pane label="会议议题" name="first">
                <div style="min-height: 100px; border: 1px solid #ccc">
                  <p
                    v-for="(item, index) in meeting.lssue"
                    :key="index"
                    style="padding: 5px">{{ index + 1 }}.{{ item }}
                  </p>
                </div>
                <el-button
                  v-if="
                    (meeting.secretary.workcode === $store.getters.username ||
                      meeting.host.workcode === $store.getters.username ||
                      meeting.convenor.workcode === $store.getters.username) &&
                    meeting.meeting_status === 1"
                  type="text"
                  size="small"
                  @click="addLssueVisible = true"
                  >添加会议议题</el-button
                >
              </el-tab-pane>
              <el-tab-pane label="会议描述" name="second">
                <div style="min-height: 100px; border: 1px solid #ccc">
                  <p style="padding: 5px">{{ meeting.describe }}</p>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <el-col :md="1" :lg="1" :xl="0">
            <div style="width: 100%; height: 1px" />
          </el-col>
          <el-col :md="24" :lg="12" :xl="24">
            <el-tabs v-model="activeName1">
              <el-tab-pane label="会议纪要" name="first">
                <el-input
                  :rows="5"
                  v-model="meeting.summary"
                  type="textarea"
                  placeholder="请输入内容"/>
                <span v-if="meeting.secretary.workcode === $store.getters.username">
                  <el-button
                    v-if="
                      meeting.meeting_status === 5 ||
                      meeting.meeting_status === 2
                    "
                    type="text"
                    size="medium"
                    @click="summary(1)"
                    >通知参会人</el-button
                  >
                </span>
                <span
                  v-if="
                    meeting.secretary.workcode === $store.getters.username ||
                    meeting.host.workcode === $store.getters.username ||
                    meeting.convenor.workcode === $store.getters.username">
                  <el-button
                    v-if="
                      meeting.meeting_status === 1 ||
                      meeting.meeting_status === 2 ||
                      meeting.meeting_status === 5"
                    type="text"
                    size="medium"
                    @click="summary(0)"
                    >保存纪要</el-button
                  >
                </span>
              </el-tab-pane>
              <el-tab-pane label="附件" name="second">
                <el-upload
                  :file-list="fileList"
                  :on-success="handleChange"
                  :headers="{ Authorization: meeting.token }"
                  :data="{
                    upload_type: 'attachment',
                    file_type: 'meeting',
                    relate_id: meeting.id}"
                  class="upload-demo"
                  :action="action"
                  name="files">

                  <el-button
                    v-if="
                      meeting.meeting_status === 1 ||
                      meeting.meeting_status === 2 ||
                      meeting.meeting_status === 5"
                    size="small"
                    type="primary"
                    >点击上传</el-button>
                </el-upload>
                <div
                  v-for="(item, index) in meeting.attachments"
                  :key="index"
                  style="padding: 5px">
                  <a :href="item.href" :key="index" style="color: #409eff">{{
                    item.filename
                  }}</a>
                  <span
              style="margin: 10px; font-size: 12px; color: red; cursor: pointer"
              @click="beforeRemove(item,index)"
              >删除</span
            >
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-col>
        <el-col :xl="1">
          <div style="width: 100%; height: 1px" />
        </el-col>
        <el-col :md="24" :lg="24" :xl="12" style="min-width:700px;overflow:auto">
          <!-- 填写任务组件 -->
          <taskView
            :meeting="meeting"
            :list="list"
            :DateFriday="DateFriday"
            :yesterday="yesterday"
            @removeDomain="removeDomain"
            >
          </taskView>
        </el-col>
      </el-row>

      <el-row />
    </div>
    <el-dialog
      :visible.sync="addAttendeesVisible"
      title="添加参会者"
      width="30%"
    >
      <el-select
        v-model="dlgname13"
        :remote-method="remoteMethod13"
        :loading="loading"
        filterable
        remote
        reserve-keyword
        placeholder="请输入,支持多选"
        style="width: 80%"
        @change="changename13"
      >
        <el-option
          v-for="item in useroptions13"
          :key="item.username"
          :label="item.label + '(' + item.value + ')'"
          :value="item"
        />
      </el-select>
      <el-tag
        v-for="(item, index) in username13"
        :key="index"
        closable
        clearable
        style="margin: 2px"
        @close="handleClose13(item)"
        >{{ item.name }}({{ item.username }})</el-tag
      >

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addAttendeesVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="addAttendeesBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog :visible.sync="addLssueVisible" title="添加会议议题" width="30%">
      <el-form label-width="80px">
        <el-form-item
          v-for="(domain, index) in lssue"
          :label="'会议议题:'"
          :key="domain.key"
        >
          <el-input v-model="domain.value">
            <template v-if="index !== 0" slot="append">
              <i
                class="el-dialog__close el-icon el-icon-close"
                @click.prevent="removeDomain2(domain)"
              />
            </template>
          </el-input>
        </el-form-item>
        <p style="text-align: center">
          <i class="el-icon-circle-plus-outline" @click="addDomain" />
        </p>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addLssueVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="addLssueBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 已预约状态，到了开始时间段进入页面时弹窗提示。早会 -->
    <el-dialog :visible.sync="startTip" title="提示" width="30%">
      <div style="position: relative">
        <span style="fontsize: 24px; marginright: 12px"
          ><i class="el-icon-warning" style="color: #f2a04b"
        /></span>
        <span style="position:absolute: line-height:26px; fontSize:18px"
          >您是否要开始早会？</span
        >
      </div>
      <div slot="footer">
        <el-button size="small" type="info" @click="startTip = false"
          >否</el-button
        >
        <el-button size="small" type="primary" @click="meetingstarts(meeting)"
          >是</el-button
        >
      </div>
    </el-dialog>
    <!-- 进行中状态，三个人提示结束会议 早会 -->
    <el-dialog :visible.sync="endTip" title="提示" width="30%">
      <div style="position: relative">
        <span style="fontsize: 24px; marginright: 12px"
          ><i class="el-icon-warning" style="color: #f2a04b"
        /></span>
        <span style="position:absolute: line-height:26px; fontSize:18px"
          >您是否要结束早会？</span
        >
      </div>
      <div slot="footer">
        <el-button size="small" type="info" @click="endTip = false"
          >否</el-button
        >
        <el-button size="small" type="primary" @click="meetingends()"
          >是</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tags from '@/components/tags'
import { gitusers } from '@/api/user'
import { meetingsummary } from '@/api/morningMeeting'
import { deepClone, transdate } from '@/utils/index'
import {
  meetingid,
  attendeessearch,
  meetingstart,
  meetingend,
  taskdelete,
  meetingupdateOngoing,
  deleteFile
} from '@/api/seedetails'

import taskView from './components/taskView'
export default {
  components: {
    tags,
    taskView
  },
  data() {
    return {
      textarea: '',
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      addAttendeesVisible: false,
      addLssueVisible: false,
      lssue: [{ value: '' }], // 添加会议议题（会议进行中）
      loading: false,
      fileList: [],
      is_complete: '0',
      attendeeslist: [],
      meeting: {
        applicant: {},
        host: {},
        secretary: {},
        convenor: {},
        contact: {},
        room: {},
        address: {},
        token: this.$store.getters.token
      },
      attendees: [],
      activeName1: 'first',
      activeNamehui: 'first',
      users: [],
      task: [
        {
          value: '',
          user: '',
          taskRadio: 'day'
        }
      ],
      value: '',
      list: [],
      username: [],
      yesterday: '',
      DateFriday: '', // 今天是周一则是上周五，
      errorMsg: [], // 任务执行失败数据
      dlgname13: '', // zhihui人，添加参会人
      useroptions13: [],
      username13: [],
      today: '',
      startTip: false,
      endTip: false,
      action: process.env.VUE_APP_BASE_API + '/common/upload'
    }
  },
  computed: {
    ...mapGetters(['roles'])
  },
  created() {
    const date = new Date()
    const Y = date.getFullYear()
    const mm = date.getMonth() + 1
    const M = mm > 9 ? mm : '0' + mm
    const D = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
    this.today = Y + '-' + M + '-' + D
    console.log('今天', this.today)
    const data = {
      departmentId: 0
    }
    gitusers(data)
      .then((response) => {
        this.users = response.data
        this.list = this.users.map((item) => {
          return { label: item.name, value: item.username }
        })
      })
      .catch((err) => {
        console.log(err)
      })
    const attendees = {
      meeting_id: this.$route.query.id,
      page: this.page,
      page_size: 1000
    }
    this.getattendeessearch(attendees)
    this.giemeetingid()
  },

  methods: {
    removeDomain(key, item) {
      var index = this.meeting.attendees[key].task.indexOf(item)
      if (index !== -1) {
        if (item.isNew) {
          this.meeting.attendees[key].task.splice(index, 1)
        } else {
          this.$confirm('确定删除？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              taskdelete(item.task_id).then((res) => {
                if (res.code === 'success') {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  this.meeting.attendees[key].task.splice(index, 1)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              })
            })
        }
      }
    },
    giemeetingid() {
      const _this = this
      meetingid(this.$route.query.id)
        .then((response) => {
          for (let index = 0; index < response.data.meeting.attachments.length; index++) {
            const element = response.data.meeting.attachments[index]
            element.href =
                `${process.env.VUE_APP_BASE_API}/common/download/` +
                element.id
          }
          response.data.meeting.token = this.$store.getters.token

          // 1、晚会开始和晚会结束：在会议预计时间当天的24点之后不再显示此两按钮
          // 2、晚会请假和晚会拒绝：在会议预计时间当天的24点之后不再显示此两按钮
          const today = new Date()
          const end_date =
            response.data.meeting.estimate_end_time.split(' ')[0] + ' 23:59:59'
          const should_date = new Date(end_date)
          if (today.getTime() > should_date.getTime()) {
            response.data.meeting.overTime = true
          } else {
            response.data.meeting.overTime = false
          }
          this.meeting = response.data.meeting
          // 取到当前会议时间的前一天
          const TD =
            this.meeting.estimate_start_time.split(' ')[0] + ' 00:00:00' // 2020-05-05
          const dateNow = new Date(TD)
          const dateYes = new Date(dateNow.getTime() - 24 * 60 * 60 * 1000)
          const Y = dateYes.getFullYear()
          const mm = dateYes.getMonth() + 1
          const M = mm < 10 ? '0' + mm : mm
          const D = dateYes.getDate() < 10 ? '0' + dateYes.getDate() : dateYes.getDate()
          this.yesterday = Y + '-' + M + '-' + D
          // 如果今天是周一，则显示上周五-周日的数据
          if (dateNow.getDay() === 1) {
            const DateFriday = new Date(dateNow.getTime() - 3 * 24 * 60 * 60 * 1000)
            const Y = DateFriday.getFullYear()
            const mm = DateFriday.getMonth() + 1
            const M = mm < 10 ? '0' + mm : mm
            const D =
              DateFriday.getDate() < 10
                ? '0' + DateFriday.getDate()
                : DateFriday.getDate()
            this.DateFriday = Y + '-' + M + '-' + D
          } else {
            this.DateFriday = ''
          }

          if (
            this.meeting.secretary.workcode === this.$store.getters.username ||
            this.meeting.host.workcode === this.$store.getters.username ||
            this.meeting.convenor.workcode === this.$store.getters.username
          ) {
            if (this.meeting.meeting_status === 0) {
              const timestamp = transdate(this.meeting.estimate_start_time) * 1000
              const timeEd = timestamp - new Date().getTime()
              this.startTip = timeEd < 3600000 && timeEd > -1800000
            }

            if (this.meeting.meeting_status === 1) {
              // 如果当前时间大于实际开始时间10分钟，弹窗提示结束，否则开定时器10分钟后弹窗
              const timestamp = transdate(this.meeting.start_time) * 1000
              const timeEd = new Date().getTime() - timestamp
              if (timeEd > 600000) {
                this.endTip = true
              } else {
                const clear = () => {
                  clearTimeout(timer)
                }
                clear()
                const timer = setTimeout(() => {
                  this.endTip = true
                }, 600000)
              }
            }
          }

          const cloneAttendees = deepClone(this.meeting.attendees)
          cloneAttendees.forEach((v, i) => {
            if (!v.task) {
              // 如果没有task 新增一个周任务和一个日任务
              let disabled = false
              let isToday = false
              if (!(
                _this.$store.getters.username === _this.meeting.host.workcode ||
                _this.$store.getters.username ===
                  _this.meeting.secretary.workcode ||
                _this.$store.getters.username ===
                  _this.meeting.convenor.workcode
              )) {
                disabled = v.workcode !== _this.$store.getters.username
              }
              if (
                _this.$store.getters.username === v.workcode ||
                _this.$store.getters.username === _this.meeting.host.workcode ||
                _this.$store.getters.username ===
                  _this.meeting.secretary.workcode ||
                _this.$store.getters.username ===
                  _this.meeting.convenor.workcode
              ) {
                isToday = true
              }
              const json = {
                value: '',
                user: {
                  value: v.workcode,
                  label: v.name
                },
                taskRadio: 'week',
                task_type: 'week',
                isNew: true,
                todayWeek: isToday,
                isDisabled: disabled
              }
              const json2 = Object.assign({}, json, { todayWeek: false, taskRadio: 'day', task_type: 'day' })
              v.task = []
              v.task.push(json)
              v.task.push(json2)
            } else {
              // 如果有任务，如果没有周任务加一个。如果没有日任务加一个
              let count1 = 0
              let count2 = 0
              v.task.forEach((item, index) => {
                if (item.task_type === 'week') {
                  count1++
                }
                if (item.task_type === 'day') {
                  count2++
                }
                let disabled = false
                if (item.task_status === 0 && (
                  _this.$store.getters.username ===
                      _this.meeting.host.workcode ||
                    _this.$store.getters.username ===
                      _this.meeting.secretary.workcode ||
                    _this.$store.getters.username ===
                      _this.meeting.convenor.workcode
                )) {
                  disabled = false
                } else {
                  disabled = true
                }
                // 周任务修改，只有是当天创建的周任务，当天才可以修改。三个人可以修改
                if (item.task_type === 'week') {
                  item.todayWeek = item.add_time.split(' ')[0] === this.today && disabled === false
                } else {
                  item.todayWeek = false
                }
                item.value = item.task_name
                item.user = {
                  value: item.confirm.workcode,
                  label: item.confirm.name
                }
                item.taskRadio = item.task_type
                item.task_id = item.id
                item.isNew = false
                item.isDisabled = disabled
              })
              if (count1 === 0) {
                let disabled = false
                let isToday = false
                if (!(
                  _this.$store.getters.username ===
                    _this.meeting.host.workcode ||
                  _this.$store.getters.username ===
                    _this.meeting.secretary.workcode ||
                  _this.$store.getters.username ===
                    _this.meeting.convenor.workcode
                )) {
                  disabled = v.workcode !== _this.$store.getters.username
                }
                if (
                  _this.$store.getters.username === v.workcode ||
                  _this.$store.getters.username ===
                    _this.meeting.host.workcode ||
                  _this.$store.getters.username ===
                    _this.meeting.secretary.workcode ||
                  _this.$store.getters.username ===
                    _this.meeting.convenor.workcode
                ) {
                  isToday = true
                }
                const json11 = {
                  value: '',
                  user: {
                    value: v.workcode,
                    label: v.name
                  },
                  taskRadio: 'week',
                  task_type: 'week',
                  isNew: true,
                  isDisabled: disabled,
                  todayWeek: isToday
                }
                v.task.push(json11)
              }
              if (count2 === 0) {
                let disabled = false
                if (!(
                  _this.$store.getters.username ===
                    _this.meeting.host.workcode ||
                  _this.$store.getters.username ===
                    _this.meeting.secretary.workcode ||
                  _this.$store.getters.username ===
                    _this.meeting.convenor.workcode
                )) {
                  disabled = v.workcode !== _this.$store.getters.username
                }
                const json22 = {
                  value: '',
                  user: {
                    value: v.workcode,
                    label: v.name
                  },
                  taskRadio: 'day',
                  task_type: 'day',
                  isNew: true,
                  isDisabled: disabled,
                  todayWeek: false
                }
                v.task.push(json22)
              }
            }
          })
          this.meeting.attendees = cloneAttendees
          console.log('该会议', this.meeting)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getattendeessearch(attendees) {
      attendeessearch(attendees)
        .then((response) => {
          console.log(response)
          this.attendees = response
          this.attendeeslist = response.data.attendees
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleChange(responses, file, fileList) {
      this.fileList = []
      this.giemeetingid()
    },
    meetingstarts(item) {
      this.$confirm('确认开始早会, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.startTip = false
          meetingstart({
            meeting_id: this.$route.query.id,
            is_night: 0
          })
            .then((response) => {
              if (response.code === 'success') {
                this.$message({
                  type: 'success',
                  message: '成功!'
                })
                this.giemeetingid()
                this.$store.dispatch('getMeetingRun')
              }
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    meetingends() {
      this.endTip = false
      this.$confirm('确认结束早会, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          meetingend({
            meeting_id: this.$route.query.id,
            is_night: 0
          })
            .then((response) => {
              this.$message({
                type: 'success',
                message: '成功!'
              })
              console.log(response)
              this.giemeetingid()
              this.$store.dispatch('getMeetingRun')
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    nightmeeting_start(item) {
      let timeEd = 0
      if (item.night_estart_time !== '0000-00-00 00:00:00') {
        const timestamp = transdate(item.night_estart_time) * 1000
        timeEd = timestamp - this.$getSevertime()
      }
      if (timeEd > 3600000) {
        this.$alert(
          '您的晚会预计时间为：' +
            item.night_estart_time +
            '，会议预计开始1小时前不能点开始！'
        )
      } else {
        this.$confirm('确认开始晚会, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            meetingstart({
              meeting_id: item.id,
              is_night: 1
            })
              .then((response) => {
                this.$message({
                  type: 'success',
                  message: '成功!'
                })
                console.log(response)
                this.giemeetingid()
                // window.location.reload()
              })
              .catch((err) => {
                console.log(err)
              })
          })
          .catch(() => {})
      }
    },
    nightmeeting_end(item) {
      this.$confirm('确认结束晚会, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          meetingend({
            meeting_id: this.$route.query.id,
            is_night: 1
          })
            .then((response) => {
              this.$message({
                type: 'success',
                message: '成功!'
              })
              console.log(response)
              this.giemeetingid()
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    // 添加参会者
    addAttendeesBtn() {
      const attendees = []
      for (let index = 0; index < this.username13.length; index++) {
        const element = this.username13[index]
        const data13 = {
          name: element.name,
          workcode: element.username
        }
        attendees.push(data13)
      }
      const obj = {
        action: 'addAttendees ',
        attendees: attendees
      }
      meetingupdateOngoing(this.$route.query.id, obj).then((res) => {
        if (res.code === 'success') {
          this.$message({
            message: '添加成功！',
            type: 'success'
          })
          this.addAttendeesVisible = false
          this.username13 = []
          this.$router.go(0) // 刷新页面
        }
      })
    },
    // 删除议题
    removeDomain2(item) {
      var index = this.lssue.indexOf(item)
      if (index !== -1) {
        this.lssue.splice(index, 1)
      }
    },
    // 添加议题
    addDomain() {
      this.lssue.push({
        value: '',
        key: Date.now()
      })
    },
    // 提交议题修改 只有会议开始中有
    addLssueBtn() {
      const params = this.lssue.map(item => { return item.value })
      const obj = {
        action: 'updateLssue  ',
        lssue: params
      }

      meetingupdateOngoing(this.$route.query.id, obj).then((res) => {
        if (res.code === 'success') {
          this.$message({
            message: '添加成功！',
            type: 'success'
          })
          this.addLssueVisible = false
          this.lssue = [{ value: '' }]
          this.$router.go(0) // 刷新
        }
      })
    },
    changename13(val) {
      // 添加参会人
      const list = {}
      list.name = this.dlgname13.label
      list.username = this.dlgname13.value
      list.id = this.dlgname13.id

      let is = true
      if (this.username13.length > 0) {
        for (let index = 0; index < this.username13.length; index++) {
          if (list.username === this.username13[index].username) {
            is = false
          }
        }
      }
      if (is) {
        this.username13.push(list)
      }
      console.log(this.username13, '13')
    },
    remoteMethod13(query) {
      // 参会人
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.useroptions13 = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.useroptions13 = []
      }
    },
    handleClose13(tag) {
      this.username13.splice(this.username13.indexOf(tag), 1)
    },
    summary(type) {
      const THIs = this
      if (this.meeting.summary === '') {
        THIs.$message({
          type: 'error',
          message: '请填写会议内容!'
        })
        return
      }
      if (type === 1) {
        this.$confirm('确认通知参会人, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            meetingsummary({
              meeting_id: THIs.$route.query.id,
              summary: THIs.meeting.summary,
              is_notice: type
            })
              .then((response) => {
                console.log(response)
                THIs.$message({
                  type: 'success',
                  message: '通知成功!'
                })
              })
              .catch((err) => {
                console.log(err)
              })
          })
          .catch(() => {
            THIs.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        meetingsummary({
          meeting_id: THIs.$route.query.id,
          summary: THIs.meeting.summary,
          is_notice: type
        })
          .then((response) => {
            console.log(response)
            THIs.$message({
              type: 'success',
              message: '保存成功!'
            })
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    beforeRemove(file, index) {
      this.$confirm('此操作将删除 ' + file.filename + ', 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteFile(file.id).then((res) => {
            if (res.code === 'success') {
              this.meeting.attachments.splice(index, 1)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style style lang="scss">
.talkCards {
  .el-card__body {
    padding: 2px 10px;
    min-width: 720px;
    overflow: auto;
  }

  .el-form-item {
    margin-bottom: 0px;
  }
}

.tipMsg {
  display: inline-block;
  line-height: 30px;
  font-size: 14px;
  color: #6d9eeb;
  font-weight: bold;
  margin-bottom: 10px;
}
</style>
<style style lang="scss" scoped>
.infoBox {
  padding: 0px 20px;
  background-color: #fff;

  .heade {
    position: relative;
    left: 115px;
    top: 11px;
  }

  .box-card {
    font-size: 14px;
    color: rgb(94, 90, 90);
  }
  .title {
    font-size: 20px;
    color: #000;
  }

  .toolBox {
    text-align: end;
  }

  .footer {
    border-top: 1px solid #ebeef5;
  }
}

.fdg {
  width: 48%;
  display: inline-block;
}

.undone {
  font-size: 12px;
  color: red;
}

.taskName {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.grid-content {
  text-align: center;
}

.el-icon-circle-plus-outline {
  font-size: 30px;
  color: rgb(223, 218, 213);
  cursor: pointer;
}

.them {
  font-weight: 700;
  font-size: 14px;
}
</style>
